import { render, staticRenderFns } from "./DropdownSample.vue?vue&type=template&id=3f11fdfa&scoped=true&"
import script from "./DropdownSample.vue?vue&type=script&lang=js&"
export * from "./DropdownSample.vue?vue&type=script&lang=js&"
import style0 from "./DropdownSample.vue?vue&type=style&index=0&id=3f11fdfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f11fdfa",
  null
  
)

export default component.exports